var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import { Grid, Paper, ListItemIcon, ListItemAvatar, Typography, Avatar } from "@mui/material";
import { v1 } from "@variable/ui-icons";
import Grid2 from '@mui/material/Unstable_Grid2'; // Grid version 2
import Fuse from 'fuse.js';
import CancelIcon from '@mui/icons-material/Cancel';
import { useConfirm, ConfirmProvider } from "material-ui-confirm";
import { pxToRem } from "../conversion";
import { Masonry } from '@mui/lab';
import { DefaultConfirm } from "./confirm";
var Cards = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var DefaultSearch = function (query, keys, data) {
    if (query === "")
        return true;
    var fuse = new Fuse([data], {
        includeScore: true,
        ignoreLocation: true,
        keys: keys
    });
    var result = fuse.search(query);
    return result && result.length > 0 && result[0] && result[0].score && result[0].score < 0.2;
};
var RawDefaultCard = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = useState(false), isAdded = _k[0], setIsAdded = _k[1];
    var _l = useState(false), isHover = _l[0], setIsHover = _l[1];
    var components = __assign({
        actions: []
    }, props.components);
    var confirm = useConfirm();
    return (_jsx(Grid, __assign({ onMouseLeave: function () { return props.deleteURL && setIsHover(false); }, onMouseOver: function () { return props.deleteURL && setIsHover(true); } }, { children: _jsxs(Paper, __assign({ sx: {
                color: 'black',
                border: '1px solid var(--palette-offwhite-3)',
                boxShadow: 'None',
                width: '176px',
                height: '200px',
                borderRadius: '0',
                position: 'relative',
                marginLeft: '-1px',
                marginTop: '-1px'
            } }, { children: [props.deleteURL && isHover &&
                    _jsx(ListItemIcon, __assign({ sx: {
                            position: 'absolute',
                            right: '12px',
                            top: '10px',
                            minWidth: 'unset',
                            cursor: 'pointer',
                        }, onClick: function () {
                            DefaultConfirm({
                                confirm: confirm,
                                components: {
                                    description: (_jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '200px' } }, { children: [_jsx(v1.UserFollow, { fontSize: "large" }), _jsx(Typography, __assign({ sx: {
                                                    font: 'normal normal normal 16px/24px Lato',
                                                    letterSpacing: '0.32px',
                                                    color: '#363636',
                                                } }, { children: "Do you want to remove this user?" })), _jsx(Typography, __assign({ sx: {
                                                    font: 'normal normal bold 16px/24px Lato',
                                                    letterSpacing: '0.32px',
                                                    color: '#1C1E33'
                                                } }, { children: props.data.name }))] }))),
                                },
                                confirmationText: 'Remove',
                            })
                                .then(function () { return props.actions.onDelete && props.actions.onDelete(); })
                                .catch(function () { });
                        } }, { children: _jsx(CancelIcon, { fontSize: "small" }) })), _jsx(ListItemAvatar, __assign({ sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '15px'
                    } }, { children: _jsx(Avatar, { src: props.data.image, sx: { width: 100, height: 100 } }) })), _jsx("a", __assign({ href: (_a = props.data) === null || _a === void 0 ? void 0 : _a.userURL, style: { textDecoration: 'none' } }, { children: _jsx(Typography, __assign({ className: "text-truncate", sx: {
                            textAlign: 'center',
                            marginTop: '5px',
                            font: "var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-14)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)",
                            letterSpacing: "var(--unnamed-character-spacing-0-28)",
                            color: "var(--palette-primary-main)",
                        }, title: props.data.name }, { children: props.data.name })) })), ((_c = (_b = props.data) === null || _b === void 0 ? void 0 : _b.organization) === null || _c === void 0 ? void 0 : _c.name) && _jsx(Typography, __assign({ className: "text-truncate", sx: {
                        textAlign: "center",
                        color: "#747474",
                        fontSize: pxToRem(14),
                    }, title: (_e = (_d = props.data) === null || _d === void 0 ? void 0 : _d.organization) === null || _e === void 0 ? void 0 : _e.name }, { children: (_g = (_f = props.data) === null || _f === void 0 ? void 0 : _f.organization) === null || _g === void 0 ? void 0 : _g.name })), ((_h = props.data) === null || _h === void 0 ? void 0 : _h.accepted) !== undefined && !((_j = props.data) === null || _j === void 0 ? void 0 : _j.accepted) && _jsx(Typography, __assign({ sx: {
                        font: "var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-medium) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)",
                        color: "var(--palette-warning-main)",
                        textAlign: "center",
                        fontSize: '13px !important'
                    } }, { children: "Pending Invitation" })), components.actions && components.actions.length > 0 && components.actions.map(function (action, index) {
                    return (_jsx(Fragment, { children: action(__assign({}, props)) }, "action".concat(index)));
                })] })) })));
};
var DefaultCard = function (props) {
    return _jsx(ConfirmProvider, { children: _jsx(RawDefaultCard, __assign({}, props)) });
};
var RawDefaultCardNew = function (props) {
    var _a, _b, _c, _d;
    var _e = useState(false), isHover = _e[0], setIsHover = _e[1];
    var components = __assign({
        actions: [],
        descriptors: []
    }, props.components);
    var confirm = useConfirm();
    return (_jsx(Grid, __assign({ onMouseLeave: function () { return props.deleteURL && setIsHover(false); }, onMouseOver: function () { return props.deleteURL && setIsHover(true); } }, { children: _jsxs(Paper, __assign({ sx: {
                color: 'black',
                border: '1px solid var(--palette-offwhite-3)',
                boxShadow: 'None',
                width: props.width || '176px',
                height: props.height || '200px',
                borderRadius: '0',
                position: 'relative',
                marginLeft: '-1px',
                marginTop: '-1px'
            } }, { children: [props.deleteURL && isHover &&
                    _jsx(ListItemIcon, __assign({ sx: {
                            position: 'absolute',
                            right: '12px',
                            top: '10px',
                            minWidth: 'unset',
                            cursor: 'pointer',
                        }, onClick: function () {
                            var _a;
                            DefaultConfirm({
                                confirm: confirm,
                                components: {
                                    description: props.components.confirm.description(__assign({}, props))
                                },
                                confirmationText: ((_a = props === null || props === void 0 ? void 0 : props.labels) === null || _a === void 0 ? void 0 : _a.confirm) || 'Remove',
                            })
                                .then(function () { return props.actions.onDelete && props.actions.onDelete(); })
                                .catch(function () { });
                        } }, { children: _jsx(CancelIcon, { fontSize: "small" }) })), _jsx(ListItemAvatar, __assign({ sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '15px'
                    } }, { children: _jsx(Avatar, { src: props.data.image, sx: { width: 100, height: 100 } }) })), _jsx("a", __assign({ href: (_a = props.data) === null || _a === void 0 ? void 0 : _a.url, style: { textDecoration: 'none' } }, { children: _jsx(Typography, __assign({ className: "text-truncate", sx: {
                            textAlign: 'center',
                            marginTop: '5px',
                            font: "var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-14)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)",
                            letterSpacing: "var(--unnamed-character-spacing-0-28)",
                            color: "var(--palette-primary-main)",
                        }, title: props.data.title }, { children: props.data.title })) })), ((_b = props.data) === null || _b === void 0 ? void 0 : _b.description) &&
                    _jsx(Typography, __assign({ className: "text-truncate", sx: {
                            font: "var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-14)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)",
                            letterSpacing: "var(--unnamed-character-spacing-0-28)",
                            color: "var(--palette-black-1)",
                            textAlign: "center",
                        }, title: (_c = props.data) === null || _c === void 0 ? void 0 : _c.description }, { children: (_d = props.data) === null || _d === void 0 ? void 0 : _d.description })), components.descriptors.map(function (d, id) {
                    return (_jsx("span", { children: d(__assign({}, props)) }, "".concat(id)));
                }), components.actions && components.actions.length > 0 && components.actions.map(function (action) {
                    return (_jsx(_Fragment, { children: action(__assign({}, props)) }));
                })] })) })));
};
var DefaultCardNew = function (props) {
    return _jsx(ConfirmProvider, { children: _jsx(RawDefaultCardNew, __assign({}, props)) });
};
var CardGrid = function (props) {
    var _a = useState(props.cardData), cardData = _a[0], setCardData = _a[1];
    var _b = useState([]), searchedData = _b[0], setSearchedData = _b[1];
    var _c = useState(props.query), query = _c[0], setQuery = _c[1];
    useEffect(function () {
        setSearchedData(props.cardData.filter(function (cardData) { return DefaultSearch(props.query, props.searchKeys, cardData); }));
    }, [props.query, props.cardData]);
    var components = __assign({
        cards: Cards,
        card: Function
    }, props.components);
    return (searchedData && props.events && props.events.cardEvents &&
        _jsx(_Fragment, { children: _jsx(components.cards, { children: _jsx(Grid2, __assign({ container: true, rowSpacing: 0, sx: { marginTop: '20px' } }, { children: searchedData.map(function (card, index) {
                        if (Array.isArray(props.components.card(__assign({ data: card }, { cardEvents: props.events.cardEvents })))) {
                            return props.components.card(__assign({ data: card }, { cardEvents: props.events.cardEvents }))[index];
                        }
                        else {
                            return props.components.card(__assign({ data: card }, { cardEvents: props.events.cardEvents }));
                        }
                    }) })) }) }));
};
var CardMasonary = function (props) {
    var _a = useState(props.cardData), cardData = _a[0], setCardData = _a[1];
    var _b = useState([]), searchedData = _b[0], setSearchedData = _b[1];
    var _c = useState(props.query), query = _c[0], setQuery = _c[1];
    useEffect(function () {
        setSearchedData(props.cardData.filter(function (cardData) { return DefaultSearch(props.query, props.searchKeys, cardData); }));
    }, [props.query, props.cardData]);
    var components = __assign({
        cards: Cards,
        card: Function
    }, props.components);
    return (searchedData && props.events && props.events.cardEvents &&
        _jsx(_Fragment, { children: _jsx(components.cards, { children: _jsx(Masonry, __assign({}, props.masonaryProps, { children: searchedData.map(function (card, index) {
                        if (Array.isArray(props.components.card(__assign({ data: card }, { cardEvents: props.events.cardEvents })))) {
                            return props.components.card(__assign({ data: card }, { cardEvents: props.events.cardEvents }))[index];
                        }
                        else {
                            return props.components.card(__assign({ data: card }, { cardEvents: props.events.cardEvents }));
                        }
                    }) })) }) }));
};
export { CardGrid, CardMasonary, Cards, DefaultCard, DefaultCardNew };
var templateObject_1;
